/**
 * LoggerService - Serviço para logar informações importantes sobre a aplicação,
 * incluindo os targets dos microserviços utilizados
 */
import {
  PROPERTY_SERVICE_URL,
  AUTH_SERVICE_URL,
  MUNICIPALITIES_SERVICE_URL,
  HUB_SERVICE_URL,
  CONSOLIDATE_SERVICE_URL,
} from './BaseApiService';

/**
 * Obtém o nome do ambiente atual com base na URL ou variável de ambiente
 * @returns {string} Nome do ambiente (development, production, homolog, etc)
 */
export function getEnvironmentName() {
  const host = window.location.hostname;

  // Detectar ambiente com base no hostname
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'development';
  } else if (host === 'app.greennexus.tech') {
    return 'homolog';
  } else {
    return 'production';
  }
}

/**
 * Obtém um mapa dos targets de todos os microserviços
 * @returns {object} Mapa com os targets dos microserviços
 */
export function getServiceTargets() {
  return {
    property: PROPERTY_SERVICE_URL,
    auth: AUTH_SERVICE_URL,
    municipios: MUNICIPALITIES_SERVICE_URL,
    hub: HUB_SERVICE_URL,
    consolidate: CONSOLIDATE_SERVICE_URL,
  };
}

/**
 * Loga os targets dos microserviços no console, semelhante ao formato do Vite
 */
export function logServiceTargets() {
  const _env = getEnvironmentName();
  const targets = getServiceTargets();

  // Formatação para garantir que os endpoints sejam exibidos claramente

  // Log detalhado para cada serviço
  Object.entries(targets).forEach(([_service, _url]) => {});

  return targets;
}

import packageJson from '../../package.json';

/**
 * Loga informações básicas sobre a aplicação
 */
export function logAppInfo() {
  // Versões e configurações da aplicação
  const _version = packageJson.version;
  const _versionDesc = import.meta.env.MODE || 'development';
  const _debug = import.meta.env.VITE_DEBUG === 'true';
  const _env = getEnvironmentName();
}

export default {
  logAppInfo,
  logServiceTargets,
  getServiceTargets,
  getEnvironmentName,
};
